import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import FormErrors from 'components/FormErrors';
import Input from 'components/Input';
import NotificationWindow from 'components/NotificationWindow';
import Validators from 'utils/fieldValidators';
import { ERROR_SERVER_ERROR } from 'utils/messages';
import './ForgotPasswordPage.css';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      message: '',
      submitting: false,
      variant: '',
      isResetSuccessful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  validate() {
    const errors = [Validators.email(this.state.email)].filter(e => !!e);

    this.setState({ errors });

    return !errors.length;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      this.setState({
        submitting: true,
        message: '',
        variant: '',
        isResetSuccessful: false
      });
      return this.props
        .forgotPassword(this.state.email)
        .then(resp => {
          if (
            resp &&
            resp.data &&
            resp.data.forgotPassword &&
            resp.data.forgotPassword.message
          ) {
            const doesMessageIncludeEmail =
              !!resp.data.forgotPassword.message.includes(this.state.email);
            this.setState({
              message: resp.data.forgotPassword.message,
              submitting: false,
              variant: 'light',
              isResetSuccessful: doesMessageIncludeEmail
            });
          } else {
            this.setState({
              message: ERROR_SERVER_ERROR,
              submitting: false,
              isResetSuccessful: false
            });
          }
          return resp;
        })
        .catch(() => {
          this.setState({
            message: ERROR_SERVER_ERROR,
            submitting: false,
            isResetSuccessful: false
          });
        });
    }
  }

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  renderForm() {
    return (
      <form className="forgot-password-page" onSubmit={this.handleSubmit}>
        <AuthWrapper closeUrl="/login" aira-label="Forgot Password Form">
          <AuthTop hideLogo>
            <h1 className="form-title">Forgot Password</h1>
            {this.state.errors && <FormErrors errors={this.state.errors} />}
            <Input
              label="Email Address"
              type="email"
              name="email"
              autoComplete="email username"
              value={this.state.email.trim()}
              onChange={this.handleChange}
              autoFocus
              required
            />
          </AuthTop>
          <AuthBottom>
            <div className="login-bottom">
              <button
                disabled={this.state.submitting}
                className="btn button-color-forgot-password-submit btn-block"
                type="submit"
              >
                <span>Submit</span>
              </button>
            </div>
          </AuthBottom>
        </AuthWrapper>
      </form>
    );
  }

  renderResetPasswordSuccess() {
    return (
      <div className="reset-password-success-section">
        <h4 className="title">Check Your Inbox</h4>
        <p className="message">
          To reset your password, follow the instructions we've sent to
        </p>
        <p className="email">{this.state.email}</p>
        <Link to="/login">
          <button type="button" className="view-wstore-confirmation-button">
            CLOSE
          </button>
        </Link>
      </div>
    );
  }

  render() {
    let content;
    if (this.state.message) {
      content = (
        <NotificationWindow
          message={this.state.message}
          closeUrl="/login"
          variant={this.state.variant || undefined}
          {...(this.state.isResetSuccessful
            ? {
                customContent: this.renderResetPasswordSuccess()
              }
            : {
                title: 'Reset Password'
              })}
        />
      );
    } else {
      content = this.renderForm();
    }

    return (
      <>
        <Helmet>
          <title>Forgot Password</title>
        </Helmet>
        {content}
      </>
    );
  }
}

const FORGOT_PASSWORD_MUTATION = gql`
  mutation MyForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
    }
  }
`;

const withMutation = graphql(FORGOT_PASSWORD_MUTATION, {
  props: ({ mutate }) => ({
    forgotPassword: email => mutate({ variables: { email } })
  })
});

export default withMutation(ForgotPasswordPage);
